module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-page",
    class: {
      "hero-page--contact": _vm.$route.path.includes("/contact")
    }
  }, [_c('NavTrigger', {
    staticClass: "hero-page__trigger--1",
    attrs: {
      "props": 0
    }
  }), _c('NavTrigger', {
    staticClass: "hero-page__trigger--2",
    attrs: {
      "props": 1
    }
  }), _c('NavTrigger', {
    staticClass: "hero-page__trigger--3",
    attrs: {
      "props": 2
    }
  }), _c('div', {
    staticClass: "hero-page__background",
    style: ("backgroundImage: url(" + _vm.props.image + ");")
  }, [(_vm.$route.path.includes("/invisalign")) ? _c('div', {
    staticClass: "hero-page__text-box"
  }, [(_vm.active) ? _c('div', {
    staticClass: "hero-page__text hero-page__text--desktop"
  }, _vm._l((_vm.stringToArrayTitle(_vm.props.text)), function(letter, i) {
    return _c('span', {
      key: i,
      style: ({
        animation: "slide-up .5s ease-in forwards",
        animationDelay: i * .01 + "s"
      }),
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    })
  })) : _vm._e(), (_vm.active && _vm.props.text_2) ? _c('div', {
    staticClass: "hero-page__text hero-page__text--desktop"
  }, _vm._l((_vm.stringToArrayTitle(_vm.props.text_2)), function(letter, i) {
    return _c('span', {
      key: i,
      style: ({
        animation: "slide-up .5s ease-in forwards",
        animationDelay: i * .01 + _vm.currentMath(_vm.props.text) + "s"
      }),
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    })
  })) : _vm._e(), (_vm.active && _vm.props.text_3) ? _c('div', {
    staticClass: "hero-page__text hero-page__text--desktop"
  }, _vm._l((_vm.stringToArrayTitle(_vm.props.text_3)), function(letter, i) {
    return _c('span', {
      key: i,
      style: ({
        animation: "slide-up .5s ease-in forwards",
        animationDelay: i * .01 + _vm.currentMath(_vm.props.text) + _vm.currentMath(_vm.props.text2) + "s"
      }),
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    })
  })) : _vm._e(), (_vm.active && _vm.props.text_4) ? _c('div', {
    staticClass: "hero-page__text hero-page__text--desktop"
  }, _vm._l((_vm.stringToArrayTitle(_vm.props.text_4)), function(letter, i) {
    return _c('span', {
      key: i,
      style: ({
        animation: "slide-up .5s ease-in forwards",
        animationDelay: i * .01 + _vm.currentMath(_vm.props.text) + _vm.currentMath(_vm.props.text2) + _vm.currentMath(_vm.props.text3) + "s"
      }),
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    })
  })) : _vm._e(), _c('div', {
    staticClass: "hero-page__text hero-page__text--mobile"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), (_vm.props.text2) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.text2)
    }
  }) : _vm._e(), (_vm.props.text3) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.text3)
    }
  }) : _vm._e(), (_vm.props.text4) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.text4)
    }
  }) : _vm._e()])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fc355c2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-page/hero-page.pug
// module id = 654
// module chunks = 1